import React, { forwardRef, ReactNode } from 'react';
import { MenuList, MenuListProps } from '@chakra-ui/react';

interface Props extends Omit<MenuListProps, `css`> {
  children: ReactNode;
}

export const DropdownList = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <MenuList ref={ref} {...props}>
        {children}
      </MenuList>
    );
  }
);
export type { Props as DropdownListProps };
